/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

import DifferentialEquation from '../pde/DifferentialEquation';
import HeatEquation from '../pde/HeatEquation';
import WaveEquation from '../pde/WaveEquation';
import GainEquation from '../pde/GainEquation';

export default class Noise extends Phase {
	wave = null;
	heat = null;
	gain = null;
	_mirror = false;
	getPreludeLength() {
		return 0;
	}
	getPostludeLength() {
		return 0;
	}
	drive() {
		throw new Error('Not implemented');
	}
	mirror() {
		this._mirror = true;
		return this;
	}
	run(args) {
		const { time, noise_opts } = args;
		const centre = this.drive(args);
		const data = noise_opts.data;
		const boundary = () => { data[0] = centre; };
		const evolver = new DifferentialEquation.Evolver(0.1 / noise_opts.npoints_const, boundary);

		const wave = this.wave = this.wave || new WaveEquation(noise_opts.data);
		const heat = this.heat = this.heat || new HeatEquation(noise_opts.data);
		const gain = this.gain = this.gain || new GainEquation(noise_opts.data);

		noise_opts.mirror = this._mirror;

		evolver.apply(time.delta,
			[wave, 1],
			[heat, 0.0003]);
		gain.apply(time.delta, 0.06, 1);
	}
}
